module.exports = __webpack_public_path__ + "img/hilton.9ba816d3.png";